// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YhZY","top":"styles_top__PSjRD","left":"styles_left__L7s0i","description":"styles_description__2B8cN"};